export const orderCheckLoginMixins = {
  watch: {
    "$store.state.user.access_token": {
      handler(newVal) {
        // console.log(this.$route);
        if (!newVal) {
          if (this.$route.meta.order) {
            if (this.session?.eventId)
              this.$router
                .push({
                  name: "Activity",
                  params: { id: this.session.eventId },
                })
                .catch(() => {});
            else this.$router.push({ name: "Index" }).catch(() => {});
          }
        }
      },
    },
  },
};

import TM from "@/api/ticket-management";
import CC from "@/api/config-center";
import { getEvent, getSessions, getProducts } from "@/api/static";
import { mapActions, mapGetters } from "vuex";
import { decrypt, encrypt } from "@/vendor/crypto";
import { initGtag } from "@/shared/utils";

export const CurrentReservedMixins = {
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
      sessionInfo: "session/sessionInfo",
      seatAssignment: "order/seatAssignment",
      areaAssignment: "order/areaAssignment",
      reserveResponse: "order/reserveResponse",
      currentReserved: "order/currentReserved",
      productData: "session/productData",
      ticketsData: "session/ticketsData",
    }),
  },
  data() {
    return {
      seatAreas: null,
      products: null,
    };
  },
  methods: {
    ...mapActions({
      setCampaign: "event/setCampaign",
      setSession: "session/setSession",
      setTicketProduct: "session/setTicketProduct",
      setTimer: "order/setTimer",
      reserveTicket: "order/reserveTicket",
      setSelectedArea: "order/setSelectedArea",
      setAreaAssignment: "order/setAreaAssignment",
      setSeatAssignment: "order/setSeatAssignment",
      setCurrentReserved: "order/setCurrentReserved",
      resetCulturePoint: "culturePoint/resetCulturePoint",
      canCulturePoint: "culturePoint/canCulturePoint",
      resetOrderState: "order/resetOrderState",
      setPopState: "order/setPopState",
      resetCountdown: "order/resetCountdown",
      setPageData: "order/setPageData",
    }),
    async getRootData(eventId, id) {
      const { data: eventsData } = await getEvent(eventId);
      const { data: sessionsData } = await getSessions(eventId);
      const sessionData = sessionsData.sessions.find((s) => s.sessionId == id);

      let [{ data: info }, getInfosErr] = await CC.getInfos({
        eventId: [eventId],
        sessionId: [id],
      });
      if (info.errCode == "00") {
        this.setCampaign({ ...eventsData, ...info.result.event[0] });
        this.setSession({
          ...sessionData,
          ...info.result.session[0],
        });
        this.setAreaAssignment(!!this.sessionInfo.ticketArea);
      }
    },
    async productInit() {
      if (
        !this.productData ||
        !this.productData.length ||
        (this.productData &&
          this.productData[0].sessionId !== this.$route.params.sessionId)
      ) {
        const { data } = await getProducts(this.$route.params.eventId);
        let products = data.products.filter(({ sessionId }) => {
          let sid = /^s[0-9]{9}$/.test(sessionId)
            ? encrypt(sessionId)
            : sessionId;
          return sid == this.$route.params.sessionId;
        });
        const [{ data: ProductInfo }, getInfosErr] = await CC.getInfos({
          productId: products.map((p) => p.productId),
        });
        products = products.map((prod) => {
          const info = ProductInfo.result.product.find(
            (p) => p.id === prod.productId
          );
          return {
            ...info,
            ...prod,
          };
        });

        this.setTicketProduct({
          products,
          tickets: this.productData.map((s) => {
            s.price = Number(s.price);
            s.remain = s.count;
            s.count = 0;
            return s;
          }),
        });

        this.$forceUpdate();
        return products;
      } else {
        return this.productData;
      }
    },
    async setTicket() {
      const productData = await this.productInit();

      return this.reserveResponse.products.reduce((accr, reserve, index) => {
        let reserves = [];
        let selectedTicket = this.tickets.find(
          (t) => t.productId === reserve.productId
        );
        const p = productData.find((p) => p.productId === reserve.productId);

        this.applicantLimit += reserve.count;
        reserves.push({
          ...p,
          ...selectedTicket,
          ...reserve,
        });
        accr = accr.concat(reserves);
        return accr;
      }, []);
    },
    async checkReservedOrder() {
      const { data: currentReserved } = await TM.getUserCurrentReservedOrder();
      if (currentReserved.tickets && currentReserved.tickets.length) {
        const [resData, getInfosErr] = await CC.getInfos({
          productId: currentReserved.tickets.map((t) => t.productId),
        });
        let reservedEventId = encrypt(resData.data.result.product[0].eventId);
        let reservedSessionId = encrypt(
          resData.data.result.product[0].sessionId
        );
        this.setCurrentReserved({
          ...currentReserved,
          reservedEventId,
          reservedEventId,
        });
        return {
          hasReservedOrder: true,
          currentReserved: currentReserved,
          reservedEventId,
          reservedSessionId,
        };
      } else {
        return { hasReservedOrder: false };
      }
    },
    async setReservedData() {
      let reservedProducts = [];
      let reservedEventId = "";
      let reservedSessionId = "";
      let reserveTickets = [];
      let selectedArea = null;

      if (this.reserveResponse.products) {
        reservedProducts = this.reserveResponse.products;
        reservedEventId = this.currentReserved
          ? this.currentReserved.reservedEventId
          : encrypt(this.reserveResponse.products[0].eventId);
        reservedSessionId = this.currentReserved
          ? this.currentReserved.reservedSessionId
          : encrypt(this.reserveResponse.products[0].sessionId);
      } else {
        const { data } = await getProducts(
          this.currentReserved.reservedEventId
        );
        const [resData, getInfosErr] = await CC.getInfos({
          productId: this.currentReserved.tickets.map((t) => t.productId),
        });
        reservedEventId = encrypt(resData.data.result.product[0].eventId);
        reservedSessionId = encrypt(resData.data.result.product[0].sessionId);

        reservedProducts = resData.data.result.product.map((prod) => {
          let p = this.currentReserved.tickets.find(
            (t) => t.productId === prod.id
          );

          let { name } = data.products.find((p) => p.productId === prod.id);

          if (p.seats) {
            let seats = p.seats.map((s) => {
              return {
                ...p,
                ...s,
                count: 1,
                name: name,
                ticketName: name,
              };
            });
            reserveTickets = reserveTickets.concat(seats);
          }

          return {
            price: Number(prod.price),
            ...prod,
            ...p,
            name: name,
            ticketName: name,
            ticketAreaName: selectedArea ? selectedArea.ticketAreaName : null,
          };
        });
      }

      await this.getRootData(reservedEventId, reservedSessionId);

      if (this.$store.state.session.sessionInfo.ticketArea) {
        let [resAreaInfo, getInfosErr] = await CC.getInfos({
          ticketAreaId: [reservedProducts[0].ticketAreaId],
        });
        selectedArea = resAreaInfo.data.result.ticketArea[0];
        this.setSelectedArea(selectedArea);
        this.setSeatAssignment(selectedArea.seatAssignment);
      }

      let order = !!this.currentReserved
        ? this.currentReserved.order
        : this.reserveResponse;
      this.reserveTicket({
        ...order,
        orderId: order.id,
        products: reservedProducts,
        tickets: reserveTickets,
      });

      let now = new Date().valueOf();
      let expire = new Date(order.expiryTimestamp).valueOf();

      this.setTimer((expire - now) / 1000 / 60);

      return {
        reservedEventId: reservedEventId,
        reservedSessionId: reservedSessionId,
      };
    },
    _initGtag(gId) {
      initGtag(gId);
    },
    async leaveConfirmation(to) {
      this.showDialog({
        title: this.$t("layout_notification_title"),
        content: this.$t("layout_notification_content"),
        buttons: [
          {
            text: this.$t("layout_notification_cancel"),
            style: {
              block: true,
              outlined: true,
              color: "primary",
            },
            action: async () => {},
          },
          {
            text: this.$t("layout_notification_confirm"),
            style: {
              depressed: true,
              block: true,
              outlined: false,
              color: "primary",
            },
            action: async () => {
              this.$store.dispatch("setOverlayLoading", true);
              const { data } = await TM.ticketRelease({
                orderId: this.reserveResponse.orderId,
                culturePointInfo: {},
              });
              if (data.errCode === "00") {
                this.resetCountdown();
                this.resetCulturePoint();
                this.resetOrderState();
                this.setPageData(null);
                this.$router
                  .push(
                    to || {
                      name: "Order1",
                      params: {
                        eventId: this.$route.params.eventId,
                        sessionId: this.$route.params.sessionId,
                      },
                    }
                  )
                  .catch((error) => {});
              }
            },
          },
        ],
      });
    },
  },
  mounted() {
    if (this.sessionInfo) this.setAreaAssignment(!!this.sessionInfo.ticketArea);
  },
};
